import { isNil } from "./types";

export const CONTACT_TYPES_BY_ID = {
    1: { id: 1, title: "words.phone", const: "PHONE" },
    2: { id: 2, title: "words.email", const: "EMAIL" },
};

export const getContactTypeById = (id) => {
    return CONTACT_TYPES_BY_ID[Number(id)] ?? null;
};

export const getContactTypeId = (contact) => {
    const id =
        contact?.contactType?.id ??
        contact?.contactTypeId ??
        contact?.contact_type_id ??
        contact?.contact_type?.id;

    return isNil(id) ? null : Number(id);
};

export const getContactType = (contact) => {
    if (contact?.contactType) return contact.contactType;

    if (contact?.contact_type) {
        return {
            id: Number(contact.contact_type.id),
            title: contact.contact_type.title,
            const: contact.contact_type.const,
        };
    }

    return getContactTypeById(getContactTypeId(contact));
};

export const isPhoneContact = (contact) => {
    return (
        getContactType(contact)?.const === "PHONE" ||
        getContactTypeId(contact) === 1
    );
};

export const isFilledContact = (contact) => {
    if (!contact || isNil(contact.value)) return false;

    const value = String(contact.value).trim();

    if (!value) return false;

    if (isPhoneContact(contact)) {
        const compact = value.replace(/[^\d+]/g, "");
        const digits = value.replace(/\D/g, "");

        return compact !== "+7" && compact !== "7" && digits.length > 1;
    }

    return true;
};
